import React, { useEffect } from 'react';
import { KFLLayout } from '@kamstrup/kamstrup-frontend-library';
import TopHeader from '../layout/topheader';
import Menu from '../layout/menu';
import Sidebar from '../layout/sidebar';
import CustomersContent from './content';
import * as Customers from '../../modules/customers';
import { Groups } from '../../models';
import ActionsBar from './actionsBar';

const CustomersPage: React.FC = () => {
  useEffect(() => Customers.updateColumns(), []);

  return (
    <KFLLayout
      topbar={<TopHeader />}
      content={<CustomersContent />}
      menu={
        <Menu title={Customers.msgTitle}>
          <ActionsBar />
        </Menu>
      }
      sidebar={<Sidebar selectedGroup={Groups.CUSTOMERS} />}
    />
  );
};

export default CustomersPage;
